import { BaseEntity, Translations } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import EntityApi from './EntityApi';

export enum AttributeViewType {
	TILES = 'tiles',
	COLOR = 'color',
	INPUT = 'input',
	THINNING = 'thinning',
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	viewType: AttributeViewType;
	listOrder: number;
	suffix?: string;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class attributeApi extends EntityApi<Attribute> {
	constructor() {
		super(QueryKey.attributes);
	}
}

export default new attributeApi();
